import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Paper } from "@material-ui/core";
import FileBase from 'react-file-base64';
import {useDispatch, useSelector} from 'react-redux';
import {createMemory,updateMemory} from '../../actions/cardsActions.js';
import "./formsStyles.css";

const Forms = ( {currentId,setCurrentId} ) => {
  const [postData, setPostData] = useState ({
    creator: "",
    title: "",
    message: "",
    tags: "",
    selectedFile: "",
  });
  const card = useSelector((state) => currentId ? state.CardsReducer.find((p)=>p._id === currentId) : null);
  
  const dispatch = useDispatch();
  useEffect(()=>{
    if(card) setPostData(card)
  },[card]);

  const handleSubmit = (e) => {
      e.preventDefault();

      if(currentId){
      dispatch(updateMemory(currentId,postData));
      }
      else{
      dispatch(createMemory(postData));
      }
      Clear();
  };

  const Clear = () => {
    setCurrentId(null);
    setPostData({
      creator: "",
      title: "",
      message: "",
      tags: "",
      selectedFile: "",
    });
  };

  return (
    <Paper className="paper">
      <form
        autoComplete="off"
        noValidate
        className={"root"+ ' ' +"form"}
        onSubmit={handleSubmit}
      >
        <Typography variant="h6">{currentId ? 'Edit' : 'Create'} Your Memory</Typography>
        <TextField
          name="creator"
          variant="outlined"
          label="Creator"
          fullWidth
          value={postData.creator}
          onChange={(e) => {
            setPostData({ ...postData, creator: e.target.value });
          }}
        />
        <TextField
          name="title"
          variant="outlined"
          label="Title"
          fullWidth
          value={postData.title}
          onChange={(e) => {
            setPostData({ ...postData, title: e.target.value });
          }}
        />
        <TextField
          name="message"
          variant="outlined"
          label="Message"
          fullWidth
          value={postData.message}
          onChange={(e) => {
            setPostData({ ...postData, message: e.target.value });
          }}
        />
        <TextField
          name="tags"
          variant="outlined"
          label="Tags"
          fullWidth
          value={postData.tags}
          onChange={(e) => {
            setPostData({ ...postData, tags: e.target.value.split(',') });
          }}
        />
        <div className="fileInput">
          <FileBase
          type="file"
          multiple={false}
          onDone={({base64}) => setPostData({...postData, selectedFile: base64})}
          />
        </div>
        <Button className="buttonSubmit" variant="contained" color="primary" size="large" type="submit" fullWidth>Submit</Button>
        <Button variant="contained" color="secondary" size="small" onClick={Clear} fullWidth>Clear</Button>
      </form>
    </Paper>
  );
};

export default Forms;
